<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="model.evidences"
      class="elevation-1 mb-7"
      no-data-text="No hay registros agregados..."
      :items-per-page="20"      
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Registro fotográfico y/o documental</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Dialog add supervisor -->
          <v-dialog v-model="dialogAddEvidence" max-width="550px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Agregar
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline"
                  >{{ titleDialogEvidence }} Registro fotográfico y/o documental</span
                >
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="formEvidence" v-model="formAddEvidence">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="modelEvidence.name"
                          label="Nombre"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                          label="Documento"
                          v-model="modelEvidence.file"
                          show-size
                          :rules="[rules.file, rules.max_file]"
                        ></v-file-input>
                      </v-col>                    
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEvidence">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveEvidence">
                  {{ titleDialogEvidence }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog delete supervisor -->
          <v-dialog v-model="dialogDeleteEvidence" max-width="520px">
            <v-card>
              <v-card-title class="headline"
                >Seguro que desea eliminar esta evidencia?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteEvidence"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteEvidenceConfirm"
                  >Aceptar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="item">
        <v-tooltip bottom v-if="edit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="deleteEvidence(item.item)"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <span v-else>N/A</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
export default {
  name: "Evidences",
  props: {
    model: {
      type: Object,
      required: true,
    },
    charge: {
      required: true,
    },
    rules: {
      required: true,
    }, 
    edit: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    currentEvidence: null,
    formAddEvidence: true,
    dialogAddEvidence: false,
    editedIndexEvidence: -1,
    dialogDeleteEvidence: false,
    modelEvidence: {
      name: "",
      file: [],
    },
    headers: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  computed: {
    titleDialogEvidence() {
      return this.currentAnnexe ? "Editar" : "Agregar";
    },
  },
  methods: {
    deleteEvidence(item) {
      this.editedIndexEvidence = this.model.evidences.indexOf(item);
      this.dialogDeleteEvidence = true;
    },
    deleteEvidenceConfirm() {
      this.model.evidences.splice(this.editedIndexEvidence, 1);
      this.closeDeleteEvidence();
    },
    closeEvidence() {
      this.dialogAddEvidence = false;
      this.$nextTick(() => {
        this.modelEvidence = {
          name: "",
          file: null,
        };
        this.editedIndexEvidence = -1;
        this.$refs.formEvidence.resetValidation();
      });
    },
    closeDeleteEvidence() {
      this.dialogDeleteEvidence = false;
      this.$nextTick(() => {
        this.currentEvidence = null;
        this.editedIndexEvidence = -1;
      });
    },
    saveEvidence() {
      if(!this.modelEvidence.name){
        this.modelEvidence.name = 'Evidencia ' + (this.model.evidences.length + 1)
      }
      //Validate inputs
      if (        
        !this.modelEvidence.name ||
        typeof this.modelEvidence.file !== "object"
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.model.evidences.push(this.modelEvidence);
      this.closeEvidence();
    },
  },
};
</script>

<style>
</style>